import { isArray } from 'lodash';
import { tr } from 'src/modules/i18n-helpers';

import { useCurrency } from '../../../hooks/useCurrency';

import FilterChip from './FilterChip';
import { CarsTableNextFilterData } from './types';
import { useFilter } from './useFilter';

type AmountSilderFilterChipProps = {
  value: any;
  name: string;
  label: string;
};

export const AmountSliderChip = ({ value, name, label }: AmountSilderFilterChipProps) => {
  const { format } = useCurrency();
  const { setValue, defaultFilter } = useFilter();

  const getLabel = () => {
    if (value[0] === '') return `<= ${format(value[1], {})}`;
    if (value[1] === '') return `>= ${format(value[0], {})}`;
    return `${format(value[0], {})} - ${format(value[1], {})}`;
  };

  if (isArray(value) && !(value[0] === '' && value[1] === ''))
    return (
      <FilterChip
        name={name}
        key={`${name}-${value}`}
        tooltip={tr(`${label}`)}
        label={getLabel()}
        onDelete={() =>
          setValue(name as keyof CarsTableNextFilterData, defaultFilter[name as keyof CarsTableNextFilterData])
        }
      />
    );
  return null;
};
